import {
  FETCH_TRANSACTION_REQUEST,
  FETCH_TRANSACTION_SUCCESS,
  FETCH_TRANSACTION_FAILURE,
} from "./transactionDetailsTypes";

const initialState = {
  loading: false,
  transactionDetails: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TRANSACTION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_TRANSACTION_SUCCESS:
      return {
        loading: false,
        transactionDetails: action.payload,
        error: "",
      };
    case FETCH_TRANSACTION_FAILURE:
      return {
        loading: false,
        transactionDetails: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
